import React from "react";
import { AuraHalfHero, type AuraHalfHeroProps } from "components/hero";
import { LottieWithStaticSafariImage } from "ui/lottie";
import staticHero from "../../../../public/assets/solutions/marketing/hero-static.png";
import animationData from "./hero-animation.json";

export function MarketingHero({
  eyebrow,
  title,
  description,
}: Pick<AuraHalfHeroProps, "eyebrow" | "title" | "description">) {
  return (
    <AuraHalfHero
      variant="yellow"
      eyebrow={eyebrow}
      title={title}
      description={description}
      mediaWrapperProps={{
        my: { base: "bigger", lg: "0" },
        w: { base: "86%", lg: "100%" },
        maxW: { base: "600px", lg: "100%" },
      }}
      media={
        <LottieWithStaticSafariImage
          isPriority
          ratio={893 / 664}
          animationData={animationData}
          image={staticHero}
          alt='An illustration showing a collection of data from a data warehouse (including users, products, accounts, and sales) being used to output conversion events, such as "Add to audience" in TikTok, "Conversion action" in HubSpot, "Add to supression" in Snapchat, and "Update contact" in Salesforce.'
        />
      }
    />
  );
}
